<template>
	<v-app>
		<loading ref="loading" />

		<!-- <v-content> -->
		<transition name="page" mode="out-in">
			<!-- <v-container fluid> -->
			<component :is="layout" v-if="layout" />
			<!-- </v-container> -->
		</transition>
		<!-- </v-content> -->
	</v-app>
</template>

<script>
import Loading from '~/components/Loading'
// Load layout components dynamically.
const requireContext = require.context('~/layouts', false, /.*\.vue$/)
const layouts = requireContext
	.keys()
	.map(file => [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)])
	.reduce((components, [name, component]) => {
		components[name] = component.default || component
		return components
	}, {})

export default {
	// name: 'App',
	el: '#app',

	components: { Loading },

	data() {
		return {
			layout: null,
			defaultLayout: 'app'
		}
	},

	metaInfo() {
		// const appName = process.env.VUE_APP_NAME

		return {
			// title: appName,
			// titleTemplate: `%s · ${appName}`
			titleTemplate: `%s`
		}
	},

	mounted() {
		this.$loading = this.$refs.loading
	},

	methods: {
		/**
		 * Set the application layout.
		 *
		 * @param {String} layout
		 */
		setLayout(layout) {
			if (!layout || !layouts[layout]) {
				layout = this.defaultLayout
			}

			this.layout = layouts[layout]
		}
	}
}
</script>
